import { getRequest, postRequest, putRequest, deleteRequest } from "api/axiosClient";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/quotation`;

const addManualQuote = (id, payload) => postRequest(`${baseURL}/${id}/add-manual-quote/`, payload);
const addAdditionalApprovers = (id, payload) => putRequest(`${baseURL}/${id}/add-additional-approvers`, payload);
const approveQuotation = (id, payload) => postRequest(`${baseURL}/${id}/approve?allow_below_level=true`, payload);
const quickApproveQuotation = (payload, config) => postRequest(`${baseURL}/quick-approval`, payload, config);
const reapproveQuotation = (id, payload) => postRequest(`${baseURL}/${id}/approve`, payload);
const cancelApprovalRequest = (id, payload) => putRequest(`${baseURL}/${id}/cancel-approval-request`, payload);
const declineApprovalRequest = (id, payload) => putRequest(`${baseURL}/${id}/decline-approval-request`, payload);
const editManualQuote = (id, payload) => putRequest(`${baseURL}/edit-manual-quote/${id}`, payload);
const editSchedule = (refernceId, payload) => putRequest(`${baseURL}/${refernceId}/edit-schedule`, payload);
const getCostDetails = (id) => getRequest(`${baseURL}/${id}/cost-details`);
const getProviderCostItems = (id) => getRequest(`${baseURL}/${id}/quote-cost-items`);
const getCustomLongfield01 = (id) => getRequest(`${REACT_APP_CARGOBASE_BASE_URL}/update-custom-longfield-01/${id}`);
const getApprovers = (id, query) => getRequest(`${baseURL}/${id}${query}`);
const getQuotationBookingForm = (id, query) => getRequest(`${baseURL}/${id}/quote-book-form-details${query}`);
const requestQuotationExtension = (id) => postRequest(`${baseURL}/${id}/request-extension`);
const updateCustomLongfield01 = (id, payload) =>
  putRequest(`${REACT_APP_CARGOBASE_BASE_URL}/update-custom-longfield-01/${id}`, payload);
const getAssignTeam = (id, config = {}) => getRequest(`${baseURL}/${id}/assign-team/`, config);
const postAssignTeam = (id, payload) => postRequest(`${baseURL}/${id}/assign-team/`, payload);
const UnassignTeam = (id, payload) => postRequest(`${baseURL}/${id}/unassign-team/`, payload);
const deleteQuoteReuest = (refernceId) => deleteRequest(`${baseURL}/${refernceId}/cancel`);
const extendQuoteRequest = (refernceId, payload) => putRequest(`${baseURL}/${refernceId}/extend`, payload);
const editQuotation = (refernceId) => postRequest(`${baseURL}/${refernceId}/start-edit`);
const confirmQuotation = (refernceId) => putRequest(`${baseURL}/${refernceId}/confirm`);
const getLatestQuotation = (config = {}) => getRequest(`${baseURL}s/latest`, config);
const getdraftQuotation = (id, shipmentId, config = {}) =>
  postRequest(`${baseURL}/draft/${id}/duplicate?shipment=${shipmentId}`, config);
const getLatestDraft = (quoteRequestId) => getRequest(`${baseURL}/latest-draft/${quoteRequestId}`);

export {
  addManualQuote,
  addAdditionalApprovers,
  approveQuotation,
  reapproveQuotation,
  cancelApprovalRequest,
  declineApprovalRequest,
  editManualQuote,
  editSchedule,
  getApprovers,
  getCostDetails,
  getCustomLongfield01,
  getQuotationBookingForm,
  getProviderCostItems,
  requestQuotationExtension,
  updateCustomLongfield01,
  getAssignTeam,
  postAssignTeam,
  UnassignTeam,
  deleteQuoteReuest,
  extendQuoteRequest,
  editQuotation,
  confirmQuotation,
  getLatestQuotation,
  getdraftQuotation,
  getLatestDraft,
  quickApproveQuotation,
};
